<highcharts-chart #treemapchart [options]="chartOptions" (chartInstance)="onChartInstance($event)"> </highcharts-chart>
